import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../styles.css';
import RestartIcon from '../../HOME/SVG/RestartIcon';
import OptionsIcon from '../../HOME/SVG/OptionsIcon';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import { REQUEST_SURRENDER_ON, REQUEST_RESET_STATS_OFF, SHOW_LEADERS, SET_RESTART_ON } from '../../HOME/REDUX/actions';
import { windowSize } from '../../HOME/utils';
import { PAUSE_ON } from '../REDUX/actions';

const Toolbar = props => {
  const dispatch = useDispatch();
  const cm = useSelector(state => state.cm);
  const { size, over } = cm;

  const handleSurrender = e => {
    props.hideOptions();

    if (canSurrender()) {
      if (over) {
        dispatch(SET_RESTART_ON);
      } else {
        dispatch(REQUEST_SURRENDER_ON);
      }

      dispatch(REQUEST_RESET_STATS_OFF);
    }
  };

  const handleLeaders = () => {
    dispatch(PAUSE_ON);
    props.hideOptions();
    dispatch({ type: SHOW_LEADERS });
  };

  const canSurrender = () => {
    return !size || cm.secs > 0;
  };

  const xmax = windowSize().x;
  const margin = Math.max(5, Math.min(10, xmax / 100));

  const styles = {
    button: { marginLeft: margin, marginRight: margin },
  };

  return (
    <div className="toolbar">
      <span className={`toolbar-button ${canSurrender() ? '' : 'toolbar-button-disabled'}`} style={styles.button} onClick={handleSurrender}>
        <RestartIcon width="36" />
      </span>
      <span className="toolbar-button" style={styles.button} onClick={handleLeaders}>
        <TrophyIcon width="36" />
      </span>
      <span className="toolbar-button" style={styles.button} onClick={props.onClickOptions}>
        <OptionsIcon width="36" id="options-button" />
      </span>
    </div>
  );
};

export default Toolbar;
